import { clsx } from "clsx";
import type { ReactNode } from "react";

export type TraxPageLayoutProps = {
	children: ReactNode;
	className?: string;
};

/**
 * Standardized full-page shell for grid pages. Renders the shared
 * `.trax-page-shell` layout (fills its flex slot in the app shell, which is
 * already sized for the global header and legal footer) and pins the page
 * header so only the content area scrolls.
 *
 * Every grid page shares the exact same shell by default so the layout
 * doesn't drift per-feature. `className` is an intentionally narrow escape
 * hatch for the rare page-specific tweak (e.g. a single spacing override) —
 * don't use it to restructure the shell itself. Place a `TraxPageHeader` as
 * the first child, followed by the page content.
 */
export const TraxPageLayout = ({
	children,
	className,
}: TraxPageLayoutProps) => {
	return <div className={clsx("trax-page-shell", className)}>{children}</div>;
};
